import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import Loader from '../../../components/Common/Loader/Loader';
import NotFound from '../../../components/NotFound/NotFound';
import AddCancelReasonForm from '../../../components/SiteAdmin/AddCancelReasonForm';
import messages from '../../../locale/messages';
import getCancelReason from './getCancelReason.graphql';
import { withQuery } from '../../../hoc/withGraphql';

export class EditCancelReason extends Component {

    render() {
        const { cancelReason: { getCancelReason, loading } } = this.props;
        const { formatMessage } = this.props.intl;

        let initialValues = {};

        if (!loading && getCancelReason?.result) {
            initialValues = {
                id: getCancelReason?.result?.id,
                reason: getCancelReason?.result?.reason,
                userType: getCancelReason?.result?.userType,
                isActive: getCancelReason?.result?.isActive
            }
        }

        if (!loading && !getCancelReason?.result?.id) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    {!loading && <AddCancelReasonForm initialValues={initialValues} />}
                </Loader>
            )
        }
    }
}

export default compose(
    injectIntl,
    withQuery(getCancelReason, {
        name: 'cancelReason',
        options: (props) => ({
            variables: {
                id: Number(props.id)
            },
            ssr: false,
            fetchPolicy: 'network-only'
        })
    })
)(EditCancelReason);